import { useQuery } from 'react-query';
import { client } from 'utils/api-client';
import { useNotification } from 'components/NotificationBanner';

export default function useFetchDashboardOverview(params: any) {
  const notification = useNotification();

  return useQuery(
    ['dashboard-overview', params],
    () => client(`dashboard/overview/`, { params }).then((res) => res.data)
    , {
      onError: (error) => {
        notification.error({
          message: "Error occurred",
          description: error.errors
        })
      }
    });
}
